
    import './styles.scoped.css';
    export default {
  "custom-range": "awsui_custom-range_16zmw_1tskr_145",
  "custom-range--no-padding": "awsui_custom-range--no-padding_16zmw_1tskr_151",
  "custom-range-form-controls": "awsui_custom-range-form-controls_16zmw_1tskr_155",
  "custom-range-duration": "awsui_custom-range-duration_16zmw_1tskr_159",
  "custom-range-unit": "awsui_custom-range-unit_16zmw_1tskr_160",
  "vertical": "awsui_vertical_16zmw_1tskr_166"
};
  